import React, { ChangeEvent } from 'react';
import { FormControl, FormErrorMessage, FormLabel, Select as ChakraSelect } from '@chakra-ui/react';
import { FieldAttributes, useField } from 'formik';

import { colors } from '~/styles/colors';
import { SelectWrapper } from './Select_Styles';

type SelectProps = {
  form: any;
  field: FieldAttributes<any>;
  children: any;
  name: string;
  label: string;
  onChange?: ChangeEvent<HTMLInputElement>;
  options: any;
  value: string;
  notNull?: boolean;
  size?: string;
};

const SelectAllGivenOptions = ({ ...props }: SelectProps) => {
  const { form, field, label, value, options, notNull, size, ...rest } = props;
  const { name } = field;
  const [, { error, touched }] = useField(name);

  return (
    <SelectWrapper>
      <FormControl className="formControl" isInvalid={!!error && touched}>
        <FormLabel className={size || 'sm'} color={colors.gray100} htmlFor={name}>
          {label}
        </FormLabel>
        <ChakraSelect marginTop="-2px" size={size || 'sm'} data-testid={name} {...field} {...rest} value={value}>
          {notNull || <option value="">Todos</option>}
          {options}
        </ChakraSelect>
        <FormErrorMessage>{error}</FormErrorMessage>
      </FormControl>
    </SelectWrapper>
  );
};

export default SelectAllGivenOptions;
